<template>
    <v-card class="line-container">
        <div class="line-img-container">
            <img
                width="106"
                src="@/assets/line-logo-big.png">
        </div>
        <div
            class="text-center locale-font"
            v-html="$vuetify.lang.t('$vuetify.lineService.description')">
        </div>
        <v-btn
            v-if="canUpdate"
            class="line-btn"
            @click="updateLine()"
            color="primary"
            width="264px"
            height="50px">
            {{ $vuetify.lang.t('$vuetify.lineService.upgradeLine') }}
        </v-btn>
        <div class="line-message-count">
            <div class="locale-font">{{ progressText }}</div>
            <div class="line-message-progress">
                <div
                    class="line-message-progress-current"
                    :style="{ width: `${progressPercentage}%` }"></div>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'LineService',

    data () {
        return {
            canUpdate: false,
            messageSent: 0,
            messageQuota: 0
        }
    },

    computed: {
        progressText () {
            const prefix = this.$vuetify.lang.t('$vuetify.lineService.messageSent')
            return `${prefix} ${this.$utils.formatNumber(this.messageSent)}/${this.$utils.formatNumber(this.messageQuota)}`
        },

        progressPercentage () {
            return this.messageQuota > 0 ? ((this.messageSent / this.messageQuota) * 100).toFixed(2) : '0'
        }
    },

    methods: {
        async updateLine () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('line/update')
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.lineService.congratulation'),
                    text: this.$vuetify.lang.t('$vuetify.lineService.lineServiceIsUpdated'),
                    type: 'success'
                })
            }
        },

        async getData () {
            const res = await this.axios.get('line/message-quota')
            if (res && res.data && res.data.status === 'ok') {
                this.messageSent = res.data.data.messageSent
                this.messageQuota = res.data.data.messageQuota
            }
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        this.canUpdate = await this.hasPermission(this.$constant.permission.COMPANY_SETTING.UPDATE)
        await this.getData()
        this.$store.dispatch('setLoading', false)
    }
}
</script>

<style lang="scss" scoped>
.line-container {
    margin-top: 2rem;
    padding: 70px 0px 45px 0px;
    border-radius: 15px !important;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05) !important;
    display: flex;
    flex-flow: column;
    align-items: center;

    .line-img-container {
        margin-bottom: 38px;
    }

    .line-btn {
        margin-top: 18px;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(215, 100, 54, 0.26);

        ::v-deep .v-btn__content {
            font-size: 18px;
        }
    }

    .line-message-count {
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        margin-top: 60px;

        .line-message-progress {
            width: 44vw;
            height: 16px;
            border-radius: 10px;
            background-color: #E9E9E9;
            margin-top: 8px;

            &-current {
                height: 16px;
                border-radius: 10px;
                background-color: #D76436;
            }
        }
    }
}
</style>
